module.exports = __webpack_public_path__ + "static/media/u-s-department-of-energy.ffdef6f0.svg";